// generated by genversion
export var version = '4.2.6';
//# sourceMappingURL=version.js.map